import React from 'react'

export default function KpiCard({ title, value }) {
	return (
		<div className="kpi-card">
			<h1>{value}</h1>
			<p>{title}</p>
		</div>
	)
}
